const React = require('react');
const css = require('./module.scss');

class Collapse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let cls = ['fp-collapse-wrap'];
        return <div className={cls.join(' ')}>
            {this.props.children}
        </div>;
    }
}

module.exports = Collapse;


// WEBPACK FOOTER //
// ./component/collapse/collapse.js